import { render, staticRenderFns } from "./CrimePanel.vue?vue&type=template&id=5cb35858&scoped=true&"
import script from "./CrimePanel.vue?vue&type=script&lang=ts&"
export * from "./CrimePanel.vue?vue&type=script&lang=ts&"
import style0 from "./CrimePanel.vue?vue&type=style&index=0&id=5cb35858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb35858",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QTable,QTr,QTh,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QTable,QTr,QTh})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
